import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=8c75fbd0&lang=less"
import "./index.vue?vue&type=style&index=1&id=8c75fbd0&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/local/v-7pa-xling/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c75fbd0"]])

export default __exports__